import React, { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../SideBar";
import { useNavigate, useParams } from "react-router-dom";

export default function EditProperty() {

    let { id } = useParams();
    let [feature, setFeature] = useState("");
    let navigate = useNavigate();
    const [formData, setFormData] = useState({
      name: "",
      projectName: "",
      type: "",
      desc: "",
      message: "",
      state: "",
      zone: "",
      permit_no: "",
      down_payment: "",
      dev_img: "",
      payment_plan: "",
      completion: "",
      location: "",
      latitude: "",
      longitude: "",
      bedrooms: "",
      floors: "",
      bathrooms: "",
      occupancy: "",
      configuration: "",
      convenience: "",
      layout: "",
      parking: "",
      view: "",
      square: "",
      price: "",
      display: "",
      status: "",
      listedBy: "",
      email: "",
      number: "",
      images: [], // handle with File input
      features: [],
      keyFeatures: "",
      exclusiveAmenities: "",
      primeLocation: "",
      propertyType: "",
      propertyStatus: "",
      addedOn: "", // date input (format: yyyy-mm-dd)
      handOverDate: "", // date input
      elevators: "",
      totalArea: "",
      buildingName: "",
      pools: "",
      mapUrl: "",
      reference: "",
    });

    useEffect(() => {
      async function getData() {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/properties/${id}`
          );
          const data = response.data;

          const formatDateForInput = (isoString) => {
            return isoString
              ? new Date(isoString).toISOString().split("T")[0]
              : "";
          };

          const normalizedData = {
            ...data,
            keyFeatures: Array.isArray(data.keyFeatures)
              ? data.keyFeatures.join(", ")
              : data.keyFeatures || "",
            exclusiveAmenities: Array.isArray(data.exclusiveAmenities)
              ? data.exclusiveAmenities.join(", ")
              : data.exclusiveAmenities || "",
            primeLocation: Array.isArray(data.primeLocation)
              ? data.primeLocation.join(", ")
              : data.primeLocation || "",
            features: data.features || [],

            // Format date strings properly
            addedOn: formatDateForInput(data.addedOn),
            handOverDate: formatDateForInput(data.handOverDate),
          };

          console.log(data);
          setFormData(normalizedData);
        } catch (error) {
          console.error("Error:", error);
        }
      }
      getData();
    }, [id]);

    const handleChange = (e) => {
      if (e.target.name === "images") {
        const files = Array.from(e.target.files);

        setFormData({ ...formData, [e.target.name]: files });
      } else {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (key === "images") {
          for (let i = 0; i < formData.images.length; i++) {
            data.append("images", formData.images[i]);
          }
        } else if (key === "features") {
          formData.features.forEach((feature) => {
            data.append("features", feature);
          });
        } else if (key === "exclusiveAmenities") {
          const exclusiveAmenitiesArray = formData.exclusiveAmenities
            ? formData.exclusiveAmenities.split(",").map((item) => item.trim())
            : [];

          exclusiveAmenitiesArray.forEach((item) => {
            data.append("exclusiveAmenities", item);
          });
        } else if (key === "keyFeatures") {
          const keyFeaturesArray = formData.keyFeatures
            ? formData.keyFeatures.split(",").map((item) => item.trim())
            : [];

          keyFeaturesArray.forEach((item) => {
            data.append("keyFeatures", item);
          });
        } else if (key === "primeLocation") {
          const primeLocationArray = formData.primeLocation
            ? formData.primeLocation.split(",").map((item) => item.trim())
            : [];

          primeLocationArray.forEach((item) => {
            data.append("primeLocation", item);
          });
        } else {
          data.append(key, formData[key]);
        }
      });
      console.log(data);
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/api/properties/${id}`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("Response Sent", response.data);
        navigate(-1);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    function handleFeatureSubmit(e) {
      e.preventDefault();
      setFormData((prev) => {
        const updatedFeatures = [...prev.features, feature];
        return { ...prev, features: updatedFeatures };
      });
    }

    function handleChangeFeature(e) {
      setFeature(e.target.value);
    }

    function navigateBack() {
      navigate(-1);
    }

    function removeFeature(index) {
      setFormData((prev) => {
        const newFeatures = [...prev.features]; // Create a copy of the array
        newFeatures.splice(index, 1); // Use splice to remove the item
        return { ...prev, features: newFeatures }; // Return the new array
      });
    }
    const sty = {
      maxHeight: "100%",
      overflow: "auto",
    };

    return (
      <>
        <div className="flex">
          <SideBar />
          <div className="flex flex-col md:mt-12 md:ml-[16%] font-sans">
            <div className="z-50 p-8 bg-white rounded-lg shadow-lg">
              <div className="flex justify-between mb-3">
                <div className="font-semibold ">Edit</div>
                <button
                  className="text-gray-500 hover:text-gray-700 focus:outline-none"
                  onClick={() => {
                    navigateBack();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div>
                <form
                  onSubmit={handleSubmit}
                  className="w-[90vw] sm:w-[80vw]"
                  enctype="multipart/form-data"
                >
                  <div className="flex">
                    <div className="flex flex-1 flex-col my-[1px] mx-2">
                      <label className="my-1 text-sm text-left" htmlFor="name">
                        Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="border px-2 w-[100%] py-1 rounded-xl text-sm"
                      />
                    </div>
                    <div className="flex flex-1 flex-col my-[1px] mx-2">
                      <label className="my-1 text-sm text-left" htmlFor="price">
                        Price <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="price"
                        value={formData.price}
                        onChange={handleChange}
                        className="border px-2 w-[100%] py-1 rounded-xl text-sm"
                      />
                    </div>
                    <div className="flex flex-1 flex-col my-[1px] mx-2">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="images"
                      >
                        Images <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="file"
                        name="images"
                        id="images"
                        multiple
                        onChange={handleChange}
                        className="w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:outline-none"
                      />
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex flex-1 flex-col my-[1px] mx-2">
                      <label className="my-1 text-sm text-left" htmlFor="desc">
                        Description <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="desc"
                        value={formData.desc}
                        onChange={handleChange}
                        className="border px-2 w-[100%] py-1 h-[15vh] rounded-xl text-sm"
                      />
                    </div>
                    <div className="flex flex-1 flex-col my-[1px] mx-2">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="keyFeatures"
                      >
                        Key Features
                      </label>
                      <textarea
                        name="keyFeatures"
                        value={formData.keyFeatures}
                        onChange={handleChange}
                        className="border px-2 w-[100%] py-1 h-[15vh] rounded-xl text-sm"
                      />
                    </div>
                  </div>

                  <div className="flex">
                    <div className="flex flex-1 flex-col my-[1px] mx-2">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="exclusiveAmenities"
                      >
                        Exclusive Amenities{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="exclusiveAmenities"
                        value={formData.exclusiveAmenities}
                        onChange={handleChange}
                        className="border px-2 w-[100%] py-1 h-[15vh] rounded-xl text-sm"
                      />
                    </div>
                    <div className="flex flex-1 flex-col my-[1px] mx-2">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="primeLocation"
                      >
                        Prime Location
                      </label>
                      <textarea
                        name="primeLocation"
                        value={formData.primeLocation}
                        onChange={handleChange}
                        className="border px-2 w-[100%] py-1 h-[15vh] rounded-xl text-sm"
                      />
                    </div>
                  </div>

                  <div className="sm:flex">
                    <div className="flex flex-1">
                      <div className="flex flex-1 mx-4 my-[1px] flex-col">
                        <label
                          className="my-1 text-sm text-left"
                          htmlFor="type"
                        >
                          Type <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="type"
                          value={formData.type}
                          onChange={handleChange}
                          className="text-sm w-[100%] border px-2 py-1 rounded-xl"
                        >
                          <option value="">None</option>
                          <option value="Rent">Rent</option>
                          <option value="Buy">Buy</option>
                          <option value="Commercial">Commercial</option>
                          <option value="HolidayHome">Holiday Home</option>
                          <option value="NewProject">New Project</option>
                        </select>
                      </div>
                      <div className="flex flex-1 mx-4 my-[1px] flex-col">
                        <label
                          className="my-1 text-sm text-left"
                          htmlFor="display"
                        >
                          Display
                        </label>
                        <select
                          name="display"
                          value={formData.display}
                          onChange={handleChange}
                          className="text-sm w-[100%] border px-2 py-1 rounded-xl"
                        >
                          <option value="apartment">Apartment</option>
                          <option value="villa">Villa</option>
                          <option value="townhouse">Townhouse</option>
                          <option value="pent_house">Pent House</option>
                          <option value="office_space">Office space</option>
                          <option value="building">Building</option>
                        </select>
                      </div>
                      <div className="flex flex-1 mx-4 my-[1px] flex-col">
                        <label
                          className="my-1 text-sm text-left"
                          htmlFor="status"
                        >
                          Status <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="status"
                          value={formData.status}
                          onChange={handleChange}
                          className="text-sm w-[100%] border px-2 py-1 rounded-xl"
                        >
                          <option value="">None</option>
                          <option value="approved">Approved</option>
                          <option value="notApproved">Not Approved</option>
                          <option value="expired">Expired</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex flex-1">
                      <div className="flex flex-1 mx-4 my-[1px] flex-col">
                        <label
                          className="my-1 text-sm text-left"
                          htmlFor="propertyStatus"
                        >
                          Property Status{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="propertyStatus"
                          value={formData.propertyStatus}
                          onChange={handleChange}
                          className="text-sm w-[100%] border px-2 py-1 rounded-xl"
                        >
                          <option value="">None</option>
                          <option value="ready">Ready</option>
                          <option value="offPlan">Off Plan</option>
                        </select>
                      </div>
                      <div className="flex flex-1 mx-4 my-[1px] flex-col">
                        <label
                          className="my-1 text-sm text-left"
                          htmlFor="propertyType"
                        >
                          Property Type <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="propertyType"
                          value={formData.propertyType}
                          onChange={handleChange}
                          className="text-sm w-[100%] border px-2 py-1 rounded-xl"
                        >
                          <option value="">None</option>
                          <option value="commercial">Commercial</option>
                          <option value="residential">Residential</option>
                          <option value="offPlan">Off Plan</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-1 my-4">
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="location"
                      >
                        Location <span className="text-red-500">*</span>
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label className="my-1 text-sm text-left" htmlFor="zone">
                        Zone
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="zone"
                        value={formData.zone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="reference"
                      >
                        Reference No
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="reference"
                        value={formData.reference}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="latitude"
                      >
                        Added on
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="date"
                        name="addedOn"
                        value={formData.addedOn}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  {/* New fields added*/}
                  <div className="flex flex-1 my-4">
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="permit_no"
                      >
                        DLD Permit No <span className="text-red-500">*</span>
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="permit_no"
                        value={formData.permit_no}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="down_payment"
                      >
                        Down Payment
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="down_payment"
                        value={formData.down_payment}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="dev_img"
                      >
                        Developer Image
                      </label>
                      <input
                        type="file"
                        name="dev_img"
                        id="dev_img"
                        onChange={handleChange}
                        className="w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:outline-none"
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="payment_plan"
                      >
                        Payment Plan
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="payment_plan"
                        value={formData.payment_plan}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="completion"
                      >
                        Completion
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="completion"
                        value={formData.completion}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  {/* New fields added end */}

                  <div className="flex flex-1 my-4">
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="longitude"
                      >
                        Longitude
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="longitude"
                        value={formData.longitude}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="latitude"
                      >
                        Latitude
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="latitude"
                        value={formData.latitude}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="occupancy"
                      >
                        Occupancy Status<span className="text-red-500">*</span>
                      </label>
                      <select
                        name="occupancy"
                        value={formData.occupancy}
                        onChange={handleChange}
                        className="text-sm w-[100%] border px-2 py-1 rounded-xl"
                      >
                        <option value="">None</option>
                        <option value="Occupied">Occupied</option>
                        <option value="Vacant">Vacant</option>
                      </select>
                    </div>
                  </div>
                  <div className="flex flex-1 my-4">
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="location"
                      >
                        Handover date <span className="text-red-500">*</span>
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="date"
                        name="handOverDate"
                        value={formData.handOverDate}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="buildingName  "
                      >
                        Building Name
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="buildingName"
                        value={formData.buildingName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="elevators"
                      >
                        Elevators
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="number"
                        name="elevators"
                        value={formData.elevators}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="totalArea"
                      >
                        Total Building Area
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="totalArea"
                        value={formData.totalArea}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="flex flex-1 my-4">
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="parking"
                      >
                        Total Parking Spaces{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="number"
                        name="parking"
                        value={formData.parking}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4 ">
                      <label className="my-1 text-sm text-left" htmlFor="pools">
                        Swimming Pools
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="number"
                        name="pools"
                        value={formData.pools}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="projectName"
                      >
                        Project Name
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="projectName"
                        value={formData.projectName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex-col flex-1 hidden mx-4 sm:flex">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="mapUrl"
                      >
                        Map Url
                      </label>
                      <input
                        className="border w-[100%] text-sm rounded-xl px-2 py-1"
                        type="text"
                        name="mapUrl"
                        value={formData.mapUrl}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="flex flex-1 my-[1px]">
                    <div className="flex flex-col flex-1 mx-1 sm:mx-4">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="bedrooms"
                      >
                        Bedroom
                      </label>
                      <input
                        className="w-[100%] text-sm border rounded-xl px-2 py-1"
                        type="number"
                        name="bedrooms"
                        value={formData.bedrooms}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-1 sm:mx-4">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="bathrooms"
                      >
                        Bathroom
                      </label>
                      <input
                        className="w-[100%] text-sm border rounded-xl px-2 py-1"
                        type="number"
                        name="bathrooms"
                        value={formData.bathrooms}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-1 sm:mx-4">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="floors"
                      >
                        Floors
                      </label>
                      <input
                        className="w-[100%] text-sm border rounded-xl px-2 py-1"
                        type="number"
                        name="floors"
                        value={formData.floors}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-1 sm:mx-4">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="square"
                      >
                        Square
                      </label>
                      <input
                        className="w-[100%] text-sm border rounded-xl px-2 py-1"
                        type="number"
                        name="square"
                        value={formData.square}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="items-center flex-1 hidden my-4 sm:flex">
                    <label
                      className="mx-4 my-1 text-sm text-left sm:block"
                      htmlFor="feature"
                    >
                      Add Feature
                    </label>
                    <div className="flex">
                      <input
                        className="border w-[100%]  px-2 py-1 text-sm"
                        type="text"
                        value={feature}
                        onChange={handleChangeFeature}
                      />
                      <button
                        onClick={handleFeatureSubmit}
                        className="px-2 text-white bg-black "
                      >
                        +
                      </button>
                    </div>
                    <div
                      className="flex overflow-x-scroll mx-4  w-[70%]"
                      id="style-1"
                    >
                      {formData.features.map((f, key) => {
                        return (
                          <div
                            key={key}
                            className="flex items-center pl-2 ml-4 text-sm text-left border whitespace-nowrap"
                          >
                            <div>{f}</div>
                            <div
                              onClick={() => {
                                removeFeature(key);
                              }}
                              className="px-3 py-1 ml-1 text-white bg-black cursor-pointer"
                            >
                              -
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex flex-col my-4 sm:flex-row">
                    <div className="flex flex-col flex-1 mx-4">
                      <label
                        className="my-1 text-sm text-left"
                        htmlFor="listedBy"
                      >
                        Listed By <span className="text-red-500 ">*</span>
                      </label>
                      <input
                        className="border my-[1px] w-[100%] rounded-xl px-2 py-1 text-sm"
                        type="text"
                        name="listedBy"
                        value={formData.listedBy}
                        onChange={handleChange}
                        placeholder="Listed By"
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4">
                      <label
                        className="hidden my-1 text-sm text-left sm:block"
                        htmlFor="email"
                      >
                        Email <span className="text-red-500 ">*</span>
                      </label>
                      <input
                        className="border my-[1px] w-[100%] rounded-xl px-2 py-1 text-sm"
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email"
                      />
                    </div>
                    <div className="flex flex-col flex-1 mx-4">
                      <label
                        className="hidden my-1 text-sm text-left sm:block"
                        htmlFor="number"
                      >
                        Number <span className="text-red-500 ">*</span>
                      </label>
                      <input
                        className="border my-[1px] w-[100%] rounded-xl px-2 py-1 text-sm"
                        type="number"
                        name="number"
                        value={formData.number}
                        onChange={handleChange}
                        placeholder="Number"
                      />
                    </div>
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="bg-black text-white px-4 py-2 rounded-lg text-sm duration-300 hover:bg-[#919191]"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

